<template>
  <v-main>
    <v-container class="fill-height" fluid>
      <v-row class="fill-height" justify="start">
        <v-col cols="12">
          <v-card color="#1976d2">
            <v-card-title primary-title class="white--text">
              <div>
                <h3 class="headline mb-2">
                  Повозрастной отчет
                </h3>
              </div>
            </v-card-title>
          </v-card>

          <v-card>
            <v-col cols="12">
              <div class="text-center">
                <v-dialog
                  v-model="loading"
                  persistent
                  width="300">
                  <v-card
                    color="primary"
                    dark>
                    <v-card-text>
                      Загружаются данные отчета
                      <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0" />
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </div>
              <v-row align="center" justify="center">
                <BaseDatePicker :value="lowestDate" label="С" @dateUpdated="dateLowerUpdated" />
                <BaseDatePicker :value="highestDate" label="По" @dateUpdated="dateHigherUpdated" />
                <BaseAutoComplete :items="places"
                                  style="margin-left: 20px;"
                                  label="Места выхода"
                                  @updateSelected="updatePlaces" />
                <BaseAutoComplete :items="genders"
                                  style="margin-left: 20px;"
                                  label="Пол"
                                  @updateSelected="updateGenders" />

                <v-card-text>
                  <v-row v-for="(slider,k) in sliders" :key="k">
                    <v-col class="shrink" style="width: 60px">
                      <v-text-field
                        v-model="slider.val[0]"
                        class="mt-0"
                        hide-details
                        single-line
                        type="number" />
                    </v-col>

                    <v-col class="px-3">
                      <v-range-slider
                        :ref="`slider-${k}`"
                        :key="`slider-${k}`"
                        v-model="slider.val"
                        :max="slider.max"
                        :min="slider.min"
                        :step="1" />
                    </v-col>

                    <v-col class="shrink" style="width: 60px">
                      <v-text-field
                        v-model="slider.val[1]"
                        class="mt-0"
                        hide-details
                        single-line
                        type="number" />
                    </v-col>
                    <div style="padding-top: 15px">
                      <v-btn v-show="k == sliders.length-1"
                             text
                             icon
                             color="green"
                             @click.prevent="add()">
                        <v-icon>add</v-icon>
                      </v-btn>
                    </div>
                    <div style="padding-top: 15px">
                      <v-btn v-show="k || ( !k && sliders.length > 1)"
                             text
                             icon
                             color="red"
                             @click="remove(k)">
                        <v-icon>remove</v-icon>
                      </v-btn>
                    </div>
                  </v-row>
                </v-card-text>

                <v-btn color="primary" class="mb-2" @click="submitSearch">
                  Поиск
                </v-btn>
              </v-row>
            </v-col>
            <!--<v-card-title primary-title>-->
            <!--<div>-->
            <!--<h3 class="headline mb-0">Повозрастной отчет</h3>-->
            <!--</div>-->
            <!--</v-card-title>-->
            <!--<DoughnutChart :data="chartData" :options="chartOptions"></DoughnutChart>-->
            <v-row class="align-left" justify="center">
              <pie-chart v-if="loaded"
                         ref="pieChart"
                         :chart-data="chartData"
                         :options="chartOptions"
                         title="Распределение по возрасту"
                         style="height: 300px; width: 300px" />
            </v-row>
            <ReportTable :data="tableData"
                         :headers="headers"
                         :loading="loading"
                         :sortable="false"
                         :is-searchable="false"
                         :table-name="'Повозрастной отчет('+lowestDate+' по '+highestDate+')'" />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from 'axios'
import ReportTable from '../ReportTable'
import BaseDatePicker from '../../base/BaseDatePicker'
import {authHeader} from '../../../_helpers/auth-header'
import {mapState} from 'vuex'
import BaseAutoComplete from '../../base/BaseAutoComplete'
// import DoughnutChart from "../charts/DoughnutChart"
import PieChart from "../../charts/PieChart.vue"

export default {
  name: "ReportAges",
  components: {
    BaseDatePicker,
    ReportTable,
    BaseAutoComplete,
    PieChart
  },
  props: {
    report: {
      type: String,
      default: '',
    }
  },
  data () {
    return {
      lowestDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().substr(0, 10),
      highestDate: new Date().toISOString().substr(0, 10),
      placesSelected: [],
      gendersSelected: [],
      loading: false,
      tableData: [],
      genders: [{name: 'М'}, {name: 'Ж'}],
      sliderLowest: [110, 440],
      sliders: [{'min':0, 'max':80, 'val':[10,80]}],

      headers: [
        {text: '', value: '', align: 'left'},
        {text: 'Возраст', value: 'bin', align: 'left', sortable: true},
        {text: 'Количество', value: 'counts', align: 'left', sortable: true},
        {text: 'Процент, %', value: 'percentage', align: 'left', sortable: true}],
      chartOptions: {
        hoverBorderWidth: 20
      },
      chartData: {},
      loaded: false,
      colors: [
        {id: 0, hex: "#f12711", disabled: false},
        {id: 1, hex: "#f5af19", disabled: false}
      ]
    }
  },
  computed: mapState({
    places: state => state.tableData.places
  }),
  methods: {
    add () {
      this.sliders.push({'min':0, 'max':80, 'val':[10,80]})
    },
    remove (index) {
      this.sliders.splice(index, 1)
    },
    dateLowerUpdated (newVal) {
      this.lowestDate = newVal
    },
    dateHigherUpdated (newVal) {
      this.highestDate = newVal
    },
    updatePlaces (newVal) {
      this.placesSelected = newVal
    },
    updateGenders (newVal) {
      this.gendersSelected = newVal
    },
    submitSearch () {
      this.loading = true
      const requestOptions = {
        method: 'GET',
        headers: authHeader()
      }
      axios({
        url: this.$store.state.tableData.backend + '/report/customers_age',
        headers: requestOptions['headers'],
        method: 'post',
        data: {
          lowestDate: this.lowestDate,
          highestDate: this.highestDate,
          placesSelected: this.placesSelected,
          gendersSelected: this.gendersSelected,
          intervals: this.sliders
        }

      }).then((response) => {
        this.loading = false
        this.tableData = JSON.parse(response.data.table)
        let allZero = response.data.pieChart['data'].every(item => item === 0)
        if (!allZero) {
          this.loaded = true
          this.chartData['datasets'] = [
            {
              label: "Распределение",
              backgroundColor: response.data.pieChart['colors'],
              data: response.data.pieChart['data']
            }
          ]
          this.chartData.labels = response.data.pieChart['labels']
          this.$refs['pieChart'].updateChart()
        }
      }).catch((error) => {
        throw new Error(`You can't load the data`)
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/reports/pages/ReportAges.vue